import anime from 'animejs/lib/anime.min.js';
import Api from "../lib/api";

export default class ItgenCheckForm {
    constructor($root, {emailCheckUri, codeCheckUri, onComplete}) {
        this.$root = $root;

        this.emailCheckUri = emailCheckUri;
        this.codeCheckUri = codeCheckUri;
        this.onComplete = onComplete;

        this.isInitialized = false;
        this.emailCheckForm = null;
        this.codeCheckForm = null;

        this.init();
    }

    init() {
        if (!this.isInitialized) {
            this.emailCheckForm = new EmailCheckForm({
                uri: this.emailCheckUri,
                onSuccess: (email) => {
                    this.codeCheckForm = new CodeCheckForm({
                        uri: this.codeCheckUri,
                        email: email,
                        onSuccess: (data) => {
                            if (this.onComplete) {
                                this.onComplete(data);
                            }
                        },
                        onBack: () => {
                            this.codeCheckForm.removeErrorState();
                            this.codeCheckForm.removeEventListeners();

                            anime({
                                targets: this.codeCheckForm.$root,
                                opacity: [{ value: 0, duration: 150 }],
                                translateX: [{ value: 200, duration: 250 }],
                                easing: 'cubicBezier(0.32, 0.08, 0.24, 1)',
                                complete: (anim) => {
                                    if (anim.completed) {
                                        this.codeCheckForm.$root.classList.remove('-active');
                                        this.emailCheckForm.$root.classList.add('-active');

                                        anime({
                                            targets: this.emailCheckForm.$root,
                                            opacity: [{ value: 0, duration: 0 }, { value: 1, duration: 250 }],
                                            translateX: [{ value: -200, duration: 0 }, { value: 0, duration: 250 }],
                                            easing: 'cubicBezier(0.32, 0.08, 0.24, 1)'
                                        });
                                    }
                                }
                            });
                        }
                    });

                    anime({
                        targets: this.emailCheckForm.$root,
                        opacity: [{ value: 0, duration: 150 }],
                        translateX: [{ value: -200, duration: 250 }],
                        easing: 'cubicBezier(0.32, 0.08, 0.24, 1)',
                        complete: (anim) => {
                            if (anim.completed) {
                                this.emailCheckForm.$root.classList.remove('-active');
                                this.codeCheckForm.$root.classList.add('-active');

                                anime({
                                    targets: this.codeCheckForm.$root,
                                    opacity: [{ value: 0, duration: 0 }, { value: 1, duration: 250 }],
                                    translateX: [{ value: 200, duration: 0 }, { value: 0, duration: 250 }],
                                    easing: 'cubicBezier(0.32, 0.08, 0.24, 1)'
                                });
                            }
                        }
                    });
                }
            });

            this.isInitialized = true;
        }
    }


}

class Form {
    constructor($root = null, { uri }) {
        this.$root = $root;
        this.$input = this.$root.querySelector('.itgen-check_input');
        this.$submit = this.$root.querySelector('.itgen-check_submit');
        this.$errorList = Array.from(this.$root.querySelectorAll('[data-error]'));

        this.uri = uri;
        this.pattern = /.+/;
        this.value = '';

        this.submitRef = (e) => this.submit(e);
        this.onInputRef = (e) => this.onInput(e);
        this.onResizeRef = (e) => this.onResize(e);

        this.init();
    }

    init() {
        this.onResize();
        this.addEventListeners();
    }

    addEventListeners() {
        this.$root.addEventListener('submit', this.submitRef);
        this.$input.addEventListener('input', this.onInputRef);
        this.$submit.addEventListener('click', this.submitRef);
        window.addEventListener('resize', this.onResizeRef);
    }

    removeEventListeners() {
        this.$root.removeEventListener('submit', this.submitRef);
        this.$input.removeEventListener('input', this.onInputRef);
        this.$submit.removeEventListener('click', this.submitRef);
        window.removeEventListener('resize', this.onResizeRef);
    }

    matchMobileLg() {
        return window.matchMedia('(max-width: 600px)').matches;
    }

    onInput(e) {
        this.value = e.target.value.trim();
        this.removeErrorState();
    }

    onResize(e) {}

    getData() {}

    showError(code = '') {
        const $error = this.$errorList.find(($error) => $error.dataset.error === code);
        $error.classList.remove('-hidden');
    }

    removeErrorState() {
        this.$input.classList.remove('-error');
        this.$errorList.forEach(($error) => $error.classList.add('-hidden'));
    }

    afterSubmit(responseData) {}

    submit(e) {
        e.preventDefault();

        if (!this.pattern.test(this.value)) {
            this.$input.classList.add('-error');
            this.showError('invalid-value');
            return;
        }

        this.$submit.disabled = true;
        this.$submit.classList.add('-progress');

        const data = this.getData();

        Api.post(`${Api.restSiteUrl}${this.uri}`, data).then((response) => {
            setTimeout(() => {
                this.$submit.classList.remove('-progress');
                this.$submit.classList.add('-ready');

                setTimeout(() => {
                    this.$submit.classList.remove('-ready');

                    this.afterSubmit(response.data);

                    this.$submit.disabled = false;
                }, 600);
            }, 1200);
        });
    }
}

class EmailCheckForm extends Form {
    constructor({ onSuccess, uri }) {
        super(document.getElementById('emailCheckForm'), { uri });

        this.onSuccess = onSuccess;
        this.pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    }

    getData() {
        return { email: this.value };
    }

    afterSubmit(responseData) {
        if (!responseData || !responseData.status) return;

        switch (responseData.status) {
            case 'completed':
            case 'signed':
                this.$input.classList.add('-error');
                this.showError('completed');
                break;
            case 'not-found':
                this.$input.classList.add('-error');
                this.showError('not-found');
                break;
            case 'ok':
                if (this.onSuccess && typeof this.onSuccess === 'function') {
                    this.onSuccess(this.value);
                }
                break;
        }
    }
}

class CodeCheckForm extends Form {
    constructor({ onSuccess, onBack, email, uri }) {
        super(document.getElementById('codeCheckForm'), { uri });

        this.email = email;
        this.onSuccess = onSuccess;
        this.onBack = onBack;
    }

    init() {
        this.$input.value = '';
        super.init();
    }

    addEventListeners() {
        super.addEventListeners();
        const $backButton = document.querySelector('.itgen-check_back');

        if ($backButton) {
            $backButton.addEventListener('click', () => this.onBack());
        }
    }

    onResize() {
        if (this.matchMobileLg()) {
            this.$input.setAttribute('placeholder', craft.localization['page.itgen-contract.form.code.placeholder.short']);
        } else {
            this.$input.setAttribute('placeholder', craft.localization['page.itgen-contract.form.code.placeholder']);
        }
    }

    getData() {
        return { email: this.email, code: this.value };
    }

    afterSubmit(responseData) {
        if (!responseData || !responseData.status) return;

        switch (responseData.status) {
            case 'wrong-code':
            case 'error':
                this.$input.classList.add('-error');
                this.showError('invalid-value');
                break;
            case 'ok':
                if (this.onSuccess && typeof this.onSuccess === 'function') {
                    this.onSuccess(responseData);
                }
                break;
        }
    }
}